const initSearch = () => {
  const input = document.querySelector('#ajax-search-input');
  const box = document.querySelector('.search-results-box');
  const results = document.querySelector('.search-results');
  const loading = document.querySelector('.search-loading');
  const viewAll = document.querySelector('.search-view-all');

  let debounceTimer;

  // Close button handlers
  const closeButtons = document.querySelectorAll('.search-close-btn, .search-bar-window-close-btn');
  closeButtons.forEach(button => {
    button.addEventListener('click', () => {
      box.classList.remove('active');
      input.value = '';
    });
  });

  // Input handler
  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(async () => {
      const query = input.value.trim();

      if (query.length < 2) {
        box.classList.remove('active');
        return;
      }

      box.classList.add('active');
      loading.style.display = 'block';
      results.innerHTML = '';

      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
        const data = await response.json();

        loading.style.display = 'none';

        const products = data?.resources?.results?.products || [];

        if (!products.length) {
          results.innerHTML = '<p style="padding:12px">No products found</p>';
          viewAll.style.display = 'none';
          return;
        }

        results.innerHTML = products
          .map(p => `
            <a href="${p.url}" class="search-result-item">
              <div class="search-result-image">
                ${p.featured_image?.url ? `<img src="${p.featured_image.url}&width=80">` : ''}
              </div>
              <div>
                <p class="search-result-title">${highlight(p.title, query)}</p>
                <div class="search-result-price">TK${formatMoney(p.price_min)}</div>
              </div>
            </a>
          `)
          .join('');

        viewAll.setAttribute('href', `/search?q=${encodeURIComponent(query)}&type=product`);
        viewAll.style.display = 'block';
      } catch (error) {
        loading.style.display = 'none';
        results.innerHTML = '<p style="padding:12px">Error loading results</p>';
      }
    }, 300);
  });

  // Helper functions
  const highlight = (text, query) => {
    const regex = new RegExp(`(${query})`, 'gi');
    return text.replace(regex, '<mark>$1</mark>');
  };

  const formatMoney = (cents) => {
    return Shopify?.formatMoney ? Shopify.formatMoney(cents) : cents;
  };
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSearch);
} else {
  initSearch();
}